export default __webpack_public_path__ + "static/media/check-payment-logo.40c7c746.svg";